import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si recién estoy arrancando con mi vinoteca?',
    a: 'Sí. El Tomo 1 empieza desde los fundamentos absolutos y el Tomo 6 tiene la guía completa para abrir una vinoteca en Argentina. El sistema está pensado tanto para los que arrancan como para los que ya tienen su local y quieren profesionalizarse.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Apenas confirmado el pago recibís un link de descarga directa. Acceso inmediato en menos de 5 minutos. Los PDFs son de alta calidad y están optimizados para leer en pantalla o imprimir.'
  }, {
    q: '¿El Nivel Maestro es necesario?',
    a: 'Depende de tu objetivo. Si solo querés mejorar tu conocimiento del vino y la atención al cliente, el Megapack base es suficiente. Si querés hacer crecer el negocio, atraer clientes y vender online, el Nivel Maestro es la mejor inversión.'
  }, {
    q: '¿Cuánto tiempo lleva implementarlo?',
    a: 'El primer día podés tener las Fichas de Degustación impresas en el mostrador y la Guía de Maridajes lista para usar. Los tomos los podés leer a tu ritmo. La mayoría de clientes implementa cambios visibles en la primera semana.'
  }, {
    q: '¿La garantía es real?',
    a: 'Sí. Escribís a packcentral23@gmail.com dentro de los 7 días y te devolvemos el 100% sin preguntas. Tenemos menos del 1% de devoluciones porque el material cumple lo que promete.'
  }, {
    q: '¿Aplica para cualquier tipo de vinoteca?',
    a: 'Sí. Vinoteca de barrio, boutique de vinos, espacio de catas, emprendimiento online o negocio en crecimiento. Todo el contenido está adaptado al mercado argentino real.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-[#0d0716]" data-id="element-48">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-49">
        <h2 className="text-3xl font-extrabold text-center text-white mb-12" data-id="element-50">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-51">
          {faqs.map((faq, i) => <div key={i} className="border border-[#3a2456] rounded-2xl overflow-hidden bg-[#1a0d2e]/60" data-id="element-52">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 hover:bg-[#3a2456]/40 transition-colors" aria-expanded={openIndex === i} data-id="element-53">
                <span className="font-bold text-white pr-4" data-id="element-54">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-55" />
              </button>

              <AnimatePresence data-id="element-56">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-57">
                    <div className="px-6 pb-5 text-slate-300 leading-relaxed border-t border-[#3a2456] pt-3" data-id="element-58">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}